

// lazy load videos on slick init
$('.hero-slider').on('init', function (event, slick) {
	$('.hero-slider .slick-slide').each(function (index, el) {
		var video = $(this).find('video source');
		var src = video.attr('data-src');
		video.attr('src', src);
	});
	
	$('.hero-slider .slick-slide').each(function (index, el) {
		
		// check if the slide is the last one
		if (index == $('.hero-slider .slick-slide').length - 1) {
			var firstSlide = $('.slick-slide').first();
			var firstSlideSuptitle = firstSlide.find('.hero-video-suptitle').html();
			var firstSlideTitle = firstSlide.find('.hero-video-title').html();
			$(this).find('.up-next .up-next-slide-suptitle').html(firstSlideSuptitle);
			$(this).find('.up-next .up-next-slide-title').html(firstSlideTitle);
		}
		else {
			var nextSlide = $(this).next('.slick-slide');
			var nextSlideSuptitle = nextSlide.find('.hero-video-suptitle').html()
			var nextSlideTitle = nextSlide.find('.hero-video-title').html();
			
			$(this).find('.up-next .up-next-slide-suptitle').html(nextSlideSuptitle);
			$(this).find('.up-next .up-next-slide-title').html(nextSlideTitle);
		}
		
		$(this).find('.next-slide').click(function () {
			goTo(index + 1);
		});
		
	}
	);
	
});

// init slick
$(".hero-slider").slick({
	infinite: true,
	arrows: false,
	dots: false,
	autoplay: false,
	fade: true,
	swipe: false,
	cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
	speed: 1200,
	slidesToShow: 1,
	slidesToScroll: 1,
	lazyLoad: 'progressive',
});

// set time to 0 on slide change
$('.hero-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	var currentVideo = $('.hero-slider .slick-track div[data-slick-index="' + nextSlide + '"] video');
	currentVideo.get(0).currentTime = 0;
	currentVideo.get(0).play();
});

$('.hero-slider').on('beforeChange', function() {
	$('.slide-content').removeClass("aos-animate");
})
$('.hero-slider').on('afterChange', function(event, slick, currentSlide) {
	$('.slide-content').addClass("aos-animate");
});

var percentTime;
var tick;
var time = 2;
var progressBarIndex = 0;
var numberOfSlides = $('.hero-slider .slick-track div[data-slick-index]').length;

function startProgressbar() {
	resetProgressbar();
	percentTime = 0;
	tick = setInterval(interval, 10);
}

// Progress bar interval and animation  
function interval() {
	if (($('.hero-slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
		progressBarIndex = $('.hero-slider .slick-track div[aria-hidden="false"]').data("slickIndex");
		startProgressbar();
	} else {
		$('.inProgress' + progressBarIndex).parent().parent().addClass("active");
		percentTime += 1 / (time + 5);
		$('.inProgress' + progressBarIndex).css({
			width: percentTime + "%"
		});
		if (percentTime >= 100) {
			$('.single-item').slick('slickNext');
			progressBarIndex++;
			if (progressBarIndex > numberOfSlides - 1) {
				progressBarIndex = 0;
				$('.progressBarContainer .item').removeClass('active');
				$('.inProgress' + progressBarIndex).parent().parent().removeClass("active");
				$('.inProgress').css({
					width: 0 + '%'
				});
			}
			startProgressbar();
		}
	}
}

function resetProgressbar() {
	clearInterval(tick);
}

function goTo(goToThisIndex) {
	
	$('.progressBarContainer .item').each(function (index) {
		if ($(this).find("span").data("slickIndex") != goToThisIndex) {
			$(this).removeClass('active');
			$(this).find('.inProgress').css({
				width: 0 + "%"
			});
		} else {
			$(this).addClass('active');
			$(this).find('.inProgress').css({
				width: 100 + "%"
			});
		}
	});
	
	$(this).addClass('active');
	
	clearInterval(tick);
	
	$('.single-item').slick('slickGoTo', goToThisIndex, false);
	startProgressbar();
}

// handle progress bar click
$('.progressBarContainer .item').click(function () {
	startProgressbar();
	goTo($(this).find("span").data("slickIndex"));
});

// init progress bar
startProgressbar();